import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import omit from 'lodash/omit';
import { unfoldObject } from 'helpers/transformers';
import { useAction, useIsBtnInProgress, useProgressSuccess } from 'hooks';
import Button from 'components/Form/Button';
import App from 'modules/App';
import * as actions from '../../../actions';
import * as selectors from '../../../selectors';
const Actions = ({ organizationProposal, onChangeView })=>{
    const isInProgress = useSelector(selectors.isCreateOrganizationInProgress);
    const hasErrors = useSelector(selectors.hasCreateOrganizationErrors);
    const createOrganization = useAction(actions.createOrganization);
    const onSuccess = ()=>{
        onChangeView('RequestSent');
    };
    useProgressSuccess(isInProgress, hasErrors, onSuccess);
    const isBtnInProgress = useIsBtnInProgress(isInProgress, hasErrors);
    const onBack = ()=>{
        onChangeView('Information');
    };
    const onSubmit = ()=>{
        const { businessEmail } = organizationProposal;
        const organizationData = unfoldObject(omit(organizationProposal, [
            'businessEmail'
        ]));
        createOrganization(organizationData, businessEmail);
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "row flex-column-reverse flex-sm-row",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "col-12 col-sm-6",
                children: /*#__PURE__*/ _jsx(Button, {
                    styleModifier: "primary",
                    labelMessage: App.messages.buttons.back,
                    className: "btn--block",
                    isDisabled: isBtnInProgress,
                    onClick: onBack
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "col-12 col-sm-6",
                children: /*#__PURE__*/ _jsx(Button, {
                    styleModifier: "primary",
                    labelMessage: App.messages.buttons.create,
                    className: "btn--block btn--filled",
                    isInProgress: isBtnInProgress,
                    onClick: onSubmit
                })
            })
        ]
    });
};
export default Actions;
